// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/icons'
// import './assets/font/font.css'
import store from './store'
import '@/permission' // permission control
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import '../node_modules/social-share.js/dist/js/social-share.min.js'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.use(Share)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js